// Generated by purs version 0.15.16
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var runExists = Unsafe_Coerce.unsafeCoerce;
var mkExists = Unsafe_Coerce.unsafeCoerce;
export {
    mkExists,
    runExists
};
//# sourceMappingURL=index.js.map
